export enum CheckoutStatus {
  CANCELED = "Canceled",
  CANCELLED = "Cancelled",
  EXPIRED = "Expired",
  FINALIZED = "Finalized",
  PAID = "Paid",
  PENDING = "Pending_payment",
  ISSUED = "Issued",
}

export const fingerprintHashSeed = 31;

export enum ConektaSource {
  EMBBEDED = "checkout-embedded",
  TOKENIZER = "token-card-form",
  PAYMENT_LINK = "payment-link",
  REDIRECTED = "checkout-redirect",
}
